import BotonTema from "@/components/BotonTema";
import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { TopNav } from "@/components/dashboard/TopNav";
import { MenuFlotante } from "@/components/dashboard/MenuFlotante";
import { EvolucionCard, DocsAnillo, AntiguedadCard } from "@/components/dashboard/PanelPrincipal";
import { useTema } from "@/lib/tema";
import { Bell } from "lucide-react";
import { CarteraKpis } from "@/components/dashboard/CarteraKpis";
import { AtenderHoy } from "@/components/dashboard/AtenderHoy";
import ResumenCoordinador from "@/components/dashboard/ResumenCoordinador";
import AdminReport from "@/components/dashboard/AdminReport";
import RankingVendedores from "@/components/dashboard/RankingVendedores";
import AdminUsersModal from "@/components/dashboard/AdminUsersModal";
import InformesCargados from "@/components/dashboard/InformesCargados";
import ModuleAccessPanel from "@/components/dashboard/ModuleAccessPanel";
import Cobranzas from "@/components/dashboard/Cobranzas";
import Cuentas from "@/components/dashboard/Cuentas";
import ClientesRevision from "@/components/dashboard/ClientesRevision";
import CarteraAlertas from "@/components/dashboard/CarteraAlertas";
import PagaresEmitidos from "@/components/dashboard/PagaresEmitidos";
import PagaresPendientes from "@/components/dashboard/PagaresPendientes";
import DeudasPlan from "@/components/dashboard/DeudasPlan";
import GestionReclamos from "@/components/dashboard/GestionReclamos";
import PermisosUsuarios from "@/components/dashboard/PermisosUsuarios";
import ClientesDocs from "@/components/dashboard/ClientesDocs";
import Logo from "@/components/Logo";
import JudicialesCruce from "@/components/dashboard/JudicialesCruce";
import RedRiesgo from "@/components/dashboard/RedRiesgo";
import CampoSatelital from "@/components/dashboard/CampoSatelital";
import Distribuidoras from "@/components/dashboard/Distribuidoras";
import Vigilancia from "@/components/dashboard/Vigilancia";
import Inmuebles from "@/components/dashboard/Inmuebles";
import AnalisisCliente from "@/components/dashboard/AnalisisCliente";
import ResumenBuscar from "@/components/dashboard/resumen/ResumenBuscar";
import Desempeno from "@/components/dashboard/desempeno/Desempeno";
import CargaCentral from "@/components/dashboard/carga/CargaCentral";
import LineasCobertura from "@/components/dashboard/LineasCobertura";
import PagaresTerceros from "@/components/dashboard/PagaresTerceros";
import CobranzasAcumuladas from "@/components/dashboard/CobranzasAcumuladas";
import AnalizarPagare from "@/components/dashboard/AnalizarPagare";
import DirectorioBtn from "@/components/dashboard/DirectorioBtn";
import Visitas from "@/components/dashboard/Visitas";
import Garantias from "@/components/dashboard/Garantias";
import ImportModal from "@/components/dashboard/ImportModal";
import Section2Import from "@/components/dashboard/Section2Import";
import WhatsAppModal from "@/components/dashboard/WhatsAppModal";
import GranosSection from "@/components/dashboard/GranosSection";
import InteresesDescuentos from "@/components/dashboard/InteresesDescuentos";
import CarteraSection from "@/components/dashboard/CarteraSection";
import PedidosSection from "@/components/dashboard/PedidosSection";
import ResetDataButton from "@/components/dashboard/ResetDataButton";
import { exportExcel, exportImageHD } from "@/lib/exportUtils";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import {
  AlertTriangle, Menu, FileDown, FileText, Loader2, Sheet, Filter, Film, CalendarRange, Mail, Phone, ListChecks,
  Image as ImageIcon, Wheat, Layers, PackageSearch, Percent, MoreHorizontal, Rows3, Rows2,
  LayoutDashboard, HandCoins, Wallet, FileClock, MapPin, ShieldCheck, Lock, BarChart3, Building2, Upload, MessageCircle, Plus, Share2, ScanText, Save, Search, Trophy,
} from "lucide-react";
import VendedoresModal from "@/components/dashboard/VendedoresModal";
import GuardarInforme from "@/components/dashboard/GuardarInforme";
import ExportPorPuntos from "@/components/dashboard/ExportPorPuntos";
import DescargarWhatsApp from "@/components/dashboard/DescargarWhatsApp";
import ChangePasswordModal from "@/components/dashboard/ChangePasswordModal";
import { toast } from "sonner";
import { safeLS } from "@/lib/safeStorage";
import ZafraConfig from "@/components/dashboard/inmuebles/ZafraConfig";

const hoyAsuncion = () => {
  const p = new Intl.DateTimeFormat("en-CA", { timeZone: "America/Asuncion", year: "numeric", month: "2-digit", day: "2-digit" }).formatToParts(new Date());
  const g = (t) => p.find((x) => x.type === t).value;
  return `${g("year")}-${g("month")}-${g("day")}`;
};
const HOY = hoyAsuncion();
const PERIODO = { inicio: `${HOY.slice(0, 7)}-01`, fin: HOY };

const NAV = [
  { id: "resumen", label: "Panel", icon: LayoutDashboard },
  { id: "cobranzas", label: "Cobranzas", icon: HandCoins },
  { id: "cuentas", label: "Cuentas a recibir", icon: Wallet },
  { id: "pagares-emitidos", label: "Pagarés emitidos", icon: FileText },
  { id: "pagares-pendientes", label: "Pagarés pendientes", icon: FileClock },
  { id: "deudas-60", label: "Deudas +60 días", icon: FileClock },
  { id: "clientes", label: "Clientes", icon: Wallet },
  { id: "visitas", label: "Visitas", icon: MapPin },
  { id: "garantias", label: "Garantías", icon: ShieldCheck },
  { id: "lineas-cobertura", label: "Cobertura de líneas", icon: ShieldCheck },
  { id: "pagares-terceros", label: "Pagarés de terceros", icon: ShieldCheck },
];

const SECTION_TITLE = {
  buscar: "Resumen",
  desempeno: "Desempeño",
  carga: "Carga central",
  resumen: "Gestión de cartera",
  cobranzas: "Cobranzas",
  cuentas: "Cuentas a recibir",
  "pagares-emitidos": "Pagarés emitidos",
  "pagares-pendientes": "Pagarés pendientes",
  "deudas-60": "Deudas de más de 60 días",
  clientes: "Documentos de clientes",
  judiciales: "Casos judiciales",
  analisis: "Análisis de cliente",
  "analisis-ext": "Análisis · otras empresas",
  visitas: "Visitas",
  garantias: "Garantías",
  gestion: "Pendientes de gestión",
  ajustes: "Ajustes y permisos",
  inmuebles: "Inmuebles de clientes",
  vigilancia: "Vigilancia de clientes",
  "red-riesgo": "Red de riesgo",
  "campo-sat": "Campo satelital",
  distribuidoras: "Alerta de distribuidoras",
  "pagares-terceros": "Pagarés de terceros",
  "lineas-cobertura": "Cobertura de líneas",
};

export default function Dashboard() {
  const { user, logout, refrescar } = useAuth();
  const isAdmin = user?.role === "admin";
  const isGranos = user?.role === "granos";
  const CARTERA_ALLOW = ["julio.sosa@tecnomyl.com", "daniel.paiva@tecnomyl.com"];
  const canCartera = CARTERA_ALLOW.includes((user?.email || "").toLowerCase());
  const esCargaAdmin = (user?.email || "").toLowerCase() === "danielpaiva87@gmail.com";
  const PEDIDOS_ALLOW = ["daniel.paiva@tecnomyl.com"];
  const canPedidos = PEDIDOS_ALLOW.includes((user?.email || "").toLowerCase());
  const DETALLE_ALLOW = ["danielpaiva87@gmail.com", "daniel.paiva@tecnomyl.com"];
  const canIntDesc = isAdmin || DETALLE_ALLOW.includes((user?.email || "").toLowerCase());
  const canDetalle = DETALLE_ALLOW.includes((user?.email || "").toLowerCase());

  const can = (k) => !(user?.denegados || []).includes(k);   // permisos que el superadministrador le quitó (frescos: se releen al abrir y al volver a la pestaña)
  useEffect(() => {
    refrescar?.();
    const f = () => document.visibilityState === "visible" && refrescar?.();
    document.addEventListener("visibilitychange", f);
    return () => document.removeEventListener("visibilitychange", f);
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps
  const puedeAjustes = isAdmin && can("ajustes");
  // La sección y el módulo viven en la dirección (?s=analisis, ?m=granos): así se pueden abrir en otra pestaña,
  // recargar sin perder el lugar y usar el botón «Atrás» del navegador.
  const urlIni = new URLSearchParams(window.location.search);
  const [section, setSection] = useState(urlIni.get("s") || "resumen");
  const [gestion, setGestion] = useState(null);
  const cargarGestion = useCallback(() => {
    api.get("/gestion/reclamos").then((r) => setGestion(r.data)).catch(() => setGestion(null));
  }, []);
  useEffect(() => { if (user && !user.docs_gestor && user.role !== "granos") cargarGestion(); }, [user, cargarGestion]);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showGranos, setShowGranos] = useState(urlIni.get("m") === "granos");
  const [showIntDesc, setShowIntDesc] = useState(urlIni.get("m") === "intdesc");
  const [showCartera, setShowCartera] = useState(urlIni.get("m") === "cartera");
  const [showPedidos, setShowPedidos] = useState(urlIni.get("m") === "pedidos");
  const [showPagareIA, setShowPagareIA] = useState(false);
  useEffect(() => {
    const m = showGranos ? "granos" : showIntDesc ? "intdesc" : showCartera ? "cartera" : showPedidos ? "pedidos" : "";
    const q = new URLSearchParams(window.location.search);
    if (m) { q.set("m", m); } else { q.delete("m"); }
    if (section && section !== "resumen") { q.set("s", section); } else { q.delete("s"); }
    const nueva = window.location.pathname + (q.toString() ? `?${q}` : "") + window.location.hash;
    if (nueva !== window.location.pathname + window.location.search + window.location.hash) window.history.pushState(null, "", nueva);
  }, [section, showGranos, showIntDesc, showCartera, showPedidos]);
  useEffect(() => {
    const atras = () => {
      const q = new URLSearchParams(window.location.search);
      const m = q.get("m");
      setSection(q.get("s") || "resumen");
      setShowGranos(m === "granos"); setShowIntDesc(m === "intdesc"); setShowCartera(m === "cartera"); setShowPedidos(m === "pedidos");
    };
    window.addEventListener("popstate", atras);
    return () => window.removeEventListener("popstate", atras);
  }, []);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [resumen, setResumen] = useState(null);
  const [periodos, setPeriodos] = useState([]);
  const [vendedor, setVendedor] = useState("__all__");
  const [mes, setMes] = useState(HOY.slice(0, 7));
  const [density, setDensity] = useState(() => safeLS.getItem("tm_density") || "compact");
  const [puntosOpen, setPuntosOpen] = useState(false);
  const [waOpen, setWaOpen] = useState(false);
  const [hdBusy, setHdBusy] = useState(false);
  const toggleDensity = () => setDensity((d) => {
    const n = d === "compact" ? "ample" : "compact";
    safeLS.setItem("tm_density", n);
    return n;
  });
  const [fechaInicio, setFechaInicio] = useState(PERIODO.inicio);
  const [fechaCorte, setFechaCorte] = useState(PERIODO.fin);
  const [focusCliente, setFocusCliente] = useState(null);
  const [analisisAbrir, setAnalisisAbrir] = useState(null);
  const [inmueblesAbrir, setInmueblesAbrir] = useState(null);
  const [catalog, setCatalog] = useState([]);
  const [visibles, setVisibles] = useState([]);
  const [isSuperadmin, setIsSuperadmin] = useState(false);

  const [judAcceso, setJudAcceso] = useState({ ver: false, cargar: false, gestionar: false });
  useEffect(() => {
    api.get("/judiciales/acceso").then((r) => setJudAcceso(r.data || {})).catch(() => setJudAcceso({ ver: false, cargar: false, gestionar: false }));
  }, [user?.email]);

  useEffect(() => {
    api.get("/superadmin/status").then((r) => setIsSuperadmin(!!r.data?.is_superadmin)).catch(() => setIsSuperadmin(false));
  }, []);

  const monthBounds = (m) => {
    const [y, mo] = m.split("-").map(Number);
    const last = new Date(y, mo, 0).getDate();
    return { first: `${m}-01`, last: `${m}-${String(last).padStart(2, "0")}` };
  };

  const onMesChange = (m) => {
    if (!m) return;
    setMes(m);
    const { first, last } = monthBounds(m);
    setFechaInicio(first);
    setFechaCorte(m === HOY.slice(0, 7) ? HOY : last);   // mes actual: Hasta = hoy; mes pasado: informe mensual completo
  };
  const irAHoy = () => onMesChange(HOY.slice(0, 7));

  useEffect(() => {
    if (!isAdmin && visibles.length === 1) setVendedor(visibles[0]);
  }, [isAdmin, visibles]);

  useEffect(() => {
    api.get("/report/periodos").then((r) => setPeriodos(r.data.periodos || [])).catch(() => {});
  }, [mes]);

  const [cargaFecha, setCargaFecha] = useState(null);
  const [cargaMes, setCargaMes] = useState(null);
  useEffect(() => {
    api.get("/report/ultima-carga").then((r) => {
      const { mes: m, fecha_corte } = r.data || {};
      if (fecha_corte) setCargaFecha(fecha_corte);
      if (m) setCargaMes(m);
      if (m) setCargaMes(m);
      if (m && m !== HOY.slice(0, 7)) { setMes(m); setFechaInicio(`${m}-01`); setFechaCorte(HOY); }
    }).catch(() => {});
  }, []);

  const loadCatalog = useCallback(async () => {
    try {
      const [c, v] = await Promise.all([api.get("/vendedores/catalog"), api.get("/vendedores/visibles")]);
      setCatalog(c.data || []);
      setVisibles(v.data?.vendedores || []);
    } catch { /* ignore */ }
  }, []);

  const loadResumen = useCallback(async () => {
    if (isGranos) return;
    const r = await api.get("/report/resumen", { params: { fecha_corte: fechaCorte, fecha_inicio: fechaInicio, periodo: mes } });
    setResumen(r.data);
  }, [fechaCorte, fechaInicio, mes, isGranos]);

  const loadSections = useCallback(async () => {
    if (isGranos) return;
    const params = { vendedor, fecha_corte: fechaCorte, fecha_inicio: fechaInicio, periodo: mes };
    const [kpis, cobranzas, cuentas, pagaresEmitidos, pagaresPendientes, visitas, garantias] =
      await Promise.all([
        api.get("/report/kpis", { params }),
        api.get("/report/cobranzas", { params }),
        api.get("/report/cuentas", { params }),
        api.get("/report/pagares-emitidos", { params }),
        api.get("/report/pagares-pendientes", { params }),
        api.get("/visitas", { params: { vendedor } }),
        api.get("/garantias"),
      ]);
    setData({
      kpis: kpis.data,
      cobranzas: cobranzas.data,
      cuentas: cuentas.data,
      pagaresEmitidos: pagaresEmitidos.data,
      pagaresPendientes: pagaresPendientes.data,
      visitas: visitas.data,
      garantias: garantias.data,
    });
    setLoading(false);
  }, [vendedor, fechaCorte, fechaInicio, mes]);

  useEffect(() => { loadResumen(); }, [loadResumen]);
  useEffect(() => { loadSections(); }, [loadSections]);
  useEffect(() => { loadCatalog(); }, [loadCatalog]);

  const reloadAll = async () => { await Promise.all([loadResumen(), loadSections()]); };

  const setLinea = async (cliente, credito, adicional) => {
    const p = api.put("/report/linea", { cliente, linea_credito: credito, adicionales: adicional, periodo: mes });
    toast.promise(p, { loading: "Guardando línea...", success: "Línea de crédito actualizada", error: "No se pudo guardar la línea" });
    await p;
    await reloadAll();
  };

  const reloadVisitas = async () => {
    const r = await api.get("/visitas", { params: { vendedor } });
    setData((d) => ({ ...d, visitas: r.data }));
  };
  const reloadGarantias = async () => {
    const r = await api.get("/garantias");
    setData((d) => ({ ...d, garantias: r.data }));
  };

  const downloadVideo = async () => {
    const p = api.post("/whatsapp/generate", {
      vendedor: vendedor || "__all__",
      include_pdf: false,
      include_video: true,
      origin: window.location.origin,
      fecha_corte: fechaCorte,
    });
    toast.promise(p, {
      loading: "Generando video resumen con gráficos...",
      success: (res) => {
        const url = res.data.media.find((m) => m.tipo === "video")?.url;
        if (url) {
          const a = document.createElement("a");
          a.href = url;
          a.target = "_blank";
          a.rel = "noreferrer";
          a.click();
        }
        return "Video listo. Se abrió en una pestaña para descargar.";
      },
      error: "No se pudo generar el video",
    });
  };

  const handleExportPDF = async () => {
    const tid = toast.loading("Generando informe… (con toda la cartera puede tardar unos minutos)");
    try {
      const { data: job } = await api.post("/informe-cartera/job", null, { params: { mes, vendedor, fecha_corte: fechaCorte } });
      let st = null;
      const t0 = Date.now();
      while (Date.now() - t0 < 20 * 60 * 1000) {
        await new Promise((r) => setTimeout(r, 2500));
        st = (await api.get(`/informe-cartera/job/${job.job_id}`, { params: { _t: Date.now() } })).data;
        if (st.status !== "running") break;
        toast.loading(`Generando informe… ${Math.round(st.elapsed || 0)} s`, { id: tid });
      }
      if (!st || st.status === "running") throw new Error("El informe tardó demasiado");
      if (st.status === "error") throw new Error(st.error || "Error al generar");
      const r = await api.get(`/informe-cartera/job/${job.job_id}/file`, { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = st.filename || `Informe_Gestion_Cartera_${mes}.pdf`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success("Informe listo", { id: tid });
    } catch (e) {
      console.error("exportPDF error", e);
      const det = e?.response?.data?.detail || e?.message || "";
      toast.error(`No se pudo generar el PDF. ${det}`.trim(), { id: tid, duration: 15000 });
    }
  };

  const handleExportExcel = () => {
    try {
      exportExcel(data);
    } catch (e) {
      console.error("exportExcel error", e);
      toast.error("No se pudo generar el Excel. Revisa la consola o vuelve a intentar.");
    }
  };

  const handleExportImageHD = async () => {
    setHdBusy(true);
    const tid = toast.loading("Generando imágenes HD del informe…");
    try {
      const r = await api.get("/informe-cartera.zip", { params: { mes, vendedor }, responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Cartera_HD_${(vendedor && vendedor !== "__all__") ? vendedor.replace(/[^A-Za-z0-9]+/g, "_") : "Todos"}_${mes}.zip`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success("Imágenes HD descargadas (.zip). Tip: en WhatsApp envialas como Documento para máxima calidad.", { id: tid, duration: 6000 });
    } catch (e) {
      console.error("exportImageHD error", e);
      toast.error("No se pudo generar la imagen HD. Vuelve a intentar.", { id: tid });
    } finally {
      setHdBusy(false);
    }
  };

  const go = (id) => { setSection(id); setSidebarOpen(false); };
  const [, alternarTema] = useTema();

  // Encargado de documentos: solo ve y trabaja la sección Clientes
  if (user?.docs_gestor)
    return (
      <div className="min-h-screen bg-[#F1F4F0]" style={{ fontFamily: "Manrope, sans-serif" }} data-testid="docs-gestor-view">
        <header className="sticky top-0 z-30 bg-[#F1F4F0]/90 backdrop-blur-md border-b border-slate-200/70 px-4 sm:px-8 py-3 flex items-center justify-between gap-3">
          <div className="flex items-center gap-4">
            <Logo />
            <h1 className="font-heading text-xl font-extrabold text-emerald-950">Clientes · documentos</h1>
          </div>
          <div className="flex items-center gap-3 text-sm text-slate-600">
            <span className="hidden sm:inline">{user?.name || user?.email}</span>
            <Button variant="outline" className="h-9" onClick={logout}>Salir</Button>
          </div>
        </header>
        <main className="px-4 sm:px-8 py-6"><ClientesDocs /></main>
      </div>
    );


  // Full-page modules (preserve existing behaviour)
  if (showIntDesc)
    return <InteresesDescuentos user={user} onLogout={logout} onBack={() => setShowIntDesc(false)} />;
  if (isGranos || showGranos) {
    if (!can("granos") || !(isAdmin || user?.granos_access))
      return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 px-8 text-center" data-testid="granos-no-access">
          <Lock className="h-12 w-12 text-red-500" />
          <h1 className="mt-4 text-lg font-bold text-slate-800">No tenés acceso a este módulo</h1>
          <p className="mt-1 text-sm text-slate-500">El módulo de Granos es exclusivo del equipo autorizado.</p>
          <button onClick={() => setShowGranos(false)} className="mt-6 rounded-lg border border-slate-200 px-4 py-2 text-sm font-semibold text-emerald-700 hover:bg-emerald-50">Volver</button>
        </div>
      );
    return <GranosSection user={user} onLogout={logout} onBack={isAdmin ? () => setShowGranos(false) : undefined} />;
  }
  if (showCartera)
    return <CarteraSection user={user} onLogout={logout} onBack={() => setShowCartera(false)} />;
  if (showPedidos)
    return <PedidosSection user={user} onLogout={logout} onBack={() => setShowPedidos(false)} />;

  if (loading || !data)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F1F4F0]">
        <Loader2 className="h-8 w-8 animate-spin text-emerald-700" />
      </div>
    );

  const derived = resumen?.vendedores || [];
  const vendedores = Array.from(
    [...visibles, ...derived].reduce((m, v) => {
      const s = (v || "").trim();
      if (!s) return m;
      const k = s.normalize("NFKD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, " ").trim().toUpperCase();
      if (!m.has(k)) m.set(k, s.replace(/\s+/g, " ").trim().toUpperCase());
      return m;
    }, new Map()).values()
  ).sort();
  const selectedVend = catalog.find((v) => v.nombre === vendedor) || null;
  const { first: mesFirst, last: mesLast } = monthBounds(mes);
  const totalClientes = (resumen?.por_vendedor || []).reduce((a, v) => a + (v.clientes || 0), 0);
  const pagaresPend = data?.kpis?.pagares_pendientes || 0;

  const NAV_PERMISO = { gestion: "gestion", resumen: "resumen", cobranzas: "cobranzas", cuentas: "cuentas", "pagares-emitidos": "pagares_emitidos",
    "pagares-pendientes": "pagares_pendientes", "deudas-60": "deudas60", clientes: "clientes", visitas: "visitas", garantias: "garantias", "lineas-cobertura": "garantias", "pagares-terceros": "garantias", judiciales: "judiciales", analisis: "analisis", "analisis-ext": "analisis" };
  const navVisible = [{ id: "buscar", label: "Resumen", icon: Search }, { id: "desempeno", label: "Desempeño", icon: Trophy }, { id: "gestion", label: `Pendientes de gestión${gestion?.total ? ` (${gestion.total})` : ""}`, icon: AlertTriangle }, ...NAV,
    ...(judAcceso.ver ? [{ id: "judiciales", label: "Casos judiciales", icon: ShieldCheck }] : []),
    ...((isAdmin || isSuperadmin) ? [{ id: "red-riesgo", label: "Red de riesgo", icon: ShieldCheck }] : []),
    { id: "campo-sat", label: "Campo satelital", icon: ShieldCheck },
    { id: "distribuidoras", label: "Alerta de distribuidoras", icon: ShieldCheck },
    { id: "vigilancia", label: "Vigilancia de clientes", icon: ShieldCheck },
    { id: "inmuebles", label: "Inmuebles de clientes", icon: ShieldCheck },
    ...((isAdmin || isSuperadmin) ? [{ id: "analisis", label: "Análisis de cliente", icon: BarChart3 }, { id: "analisis-ext", label: "Otras empresas", icon: Building2 }] : []),
    ...(esCargaAdmin ? [{ id: "carga", label: "Carga central", icon: Upload }] : [])].filter((n) => can(NAV_PERMISO[n.id] || n.id));
  // si la sección abierta está oculta para este usuario, se muestra la primera que sí puede ver
  const secActual = section !== "ajustes" && navVisible.length > 0 && !navVisible.some((n) => n.id === section) ? navVisible[0].id : section;

  const moduleItems = [
    (can("granos") && (isAdmin || user?.granos_access)) && { id: "mod-granos", href: "?m=granos", label: "Granos", icon: Wheat, onClick: () => { setShowGranos(true); setSidebarOpen(false); } },
    (can("intdesc") && canIntDesc) && { id: "mod-intdesc", href: "?m=intdesc", label: "Intereses y Descuentos", icon: Percent, onClick: () => { setShowIntDesc(true); setSidebarOpen(false); } },
    (can("cartera_venc") && canCartera) && { id: "mod-cartera", href: "?m=cartera", label: "Cartera · Vencimientos", icon: Layers, onClick: () => { setShowCartera(true); setSidebarOpen(false); } },
    (can("pedidos") && canPedidos) && { id: "mod-pedidos", href: "?m=pedidos", label: "Pedidos de Ventas", icon: PackageSearch, onClick: () => { setShowPedidos(true); setSidebarOpen(false); } },
    can("analizar_pagare") && { id: "mod-pagare-ia", label: "Analizar pagaré (IA)", icon: ScanText, onClick: () => { setShowPagareIA(true); setSidebarOpen(false); } },
  ].filter(Boolean);

  const exportOpts = { coordinador: user?.name, fechaCorte, vendedorInfo: selectedVend, periodo: { inicio: fechaInicio, fin: fechaCorte } };

  const FilterBar = () => (
    <div className="flex items-center gap-3 flex-wrap">
      <div className="flex items-center gap-2 tm-crema px-3 py-1.5 rounded-full min-w-fit">
        <CalendarRange className="h-4 w-4 text-emerald-700" />
        <span className="text-xs font-medium text-slate-500 hidden sm:inline">Mes:</span>
        <input type="month" data-testid="mes-informe-input" value={mes} onChange={(e) => onMesChange(e.target.value)}
          className="h-9 rounded-lg border border-slate-200 bg-white px-3 text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-emerald-500" />
      </div>
      <div className="flex items-center gap-2 tm-crema px-3 py-1.5 rounded-full min-w-fit">
        <span className="text-xs font-medium text-slate-500 hidden sm:inline">Desde:</span>
        <input type="date" data-testid="fecha-inicio-input" value={fechaInicio} min={mesFirst} max={fechaCorte}
          onChange={(e) => setFechaInicio(e.target.value || mesFirst)}
          className="h-9 rounded-lg border border-slate-200 bg-white px-3 text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-emerald-500" />
      </div>
      <div className="flex items-center gap-2 tm-crema px-3 py-1.5 rounded-full min-w-fit">
        <span className="text-xs font-medium text-slate-500 hidden sm:inline">Hasta:</span>
        <input type="date" data-testid="fecha-corte-input" value={fechaCorte} min={fechaInicio} max={mesLast}
          onChange={(e) => setFechaCorte(e.target.value || mesLast)}
          className="h-9 rounded-lg border border-slate-200 bg-white px-3 text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-emerald-500" />
      </div>
      <button type="button" onClick={irAHoy} data-testid="filtro-hoy" className="h-9 px-3 rounded-full text-xs font-semibold tm-crema text-emerald-800 hover:bg-emerald-50" title="Mes actual · hasta hoy">Hoy</button>
      <span className="text-xs text-slate-500" data-testid="datos-al">{cargaFecha && cargaMes && mes >= cargaMes ? `Datos de la carga del ${cargaFecha.split("-").reverse().join("/")}` : `Datos al ${fechaCorte.split("-").reverse().join("/")}`}</span>
      <div className="flex items-center gap-2 tm-crema px-3 py-1.5 rounded-full min-w-fit">
        <Filter className="h-4 w-4 text-emerald-700" />
        <Select value={vendedor} onValueChange={setVendedor} disabled={!isAdmin && vendedores.length <= 1}>
          <SelectTrigger data-testid="vendedor-filter" className="h-9 w-52 bg-white rounded-lg"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="__all__">{isAdmin ? "Todos los vendedores" : "Todos mis vendedores"}</SelectItem>
            {vendedores.map((v) => (<SelectItem key={v} value={v}>{v}</SelectItem>))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );

  const VendedorBar = () => (
    <div className="flex items-center gap-2 tm-crema px-3 py-1.5 rounded-full min-w-fit" data-testid="vendedor-bar">
      <Filter className="h-4 w-4 text-emerald-700" />
      <Select value={vendedor} onValueChange={setVendedor} disabled={!isAdmin && vendedores.length <= 1}>
        <SelectTrigger data-testid="vendedor-filter" className="h-9 w-52 bg-white rounded-lg"><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value="__all__">{isAdmin ? "Todos los vendedores" : "Todos mis vendedores"}</SelectItem>
          {vendedores.map((v) => (<SelectItem key={v} value={v}>{v}</SelectItem>))}
        </SelectContent>
      </Select>
    </div>
  );

  const renderSection = () => {
    switch (secActual) {
      case "buscar":
        return <ResumenBuscar kpis={data.kpis} onVerCliente={(c) => { setFocusCliente(c); go("cuentas"); }}
          onAbrirInmuebles={(cod) => { setInmueblesAbrir(cod); go("inmuebles"); }}
          onAbrirAnalisis={(isAdmin || isSuperadmin) ? (id) => { setAnalisisAbrir(id); go("analisis"); } : null} />;
      case "desempeno":
        return <Desempeno />;
      case "carga":
        return esCargaAdmin ? <CargaCentral /> : null;
      case "lineas-cobertura":
        return <LineasCobertura />;
      case "pagares-terceros":
        return <PagaresTerceros />;
      case "resumen":
        return (
          <div id="report-capture" className="space-y-6">
            {periodos.length > 1 && (
              <div data-testid="periodos-disponibles" className="flex flex-wrap items-center gap-2">
                <span className="text-xs text-slate-400">Meses con datos:</span>
                {periodos.map((p) => (
                  <button key={p} data-testid={`periodo-chip-${p}`} onClick={() => onMesChange(p)}
                    className={`text-xs px-2.5 py-1 rounded-full border transition-colors ${p === mes ? "bg-emerald-600 text-white border-emerald-600" : "bg-white text-slate-600 border-slate-200 hover:border-emerald-300"}`}>
                    {p}
                  </button>
                ))}
              </div>
            )}

            {vendedor !== "__all__" && (
              <div data-testid="active-filter-banner" className="rounded-xl bg-emerald-100 border border-emerald-200 px-4 py-3 text-sm text-emerald-900 flex flex-wrap items-center gap-x-4 gap-y-1">
                <span className="flex items-center gap-2"><Filter className="h-4 w-4" /> Informe individual: <strong>{vendedor}</strong></span>
                {selectedVend?.email && <span className="flex items-center gap-1.5 text-emerald-800"><Mail className="h-3.5 w-3.5" /> {selectedVend.email}</span>}
                {selectedVend?.telefono && <span className="flex items-center gap-1.5 text-emerald-800"><Phone className="h-3.5 w-3.5" /> {selectedVend.telefono}</span>}
                <button onClick={() => setVendedor("__all__")} className="ml-auto text-emerald-700 font-semibold hover:underline" data-testid="clear-filter">Ver todos</button>
              </div>
            )}

            {gestion?.total > 0 && (
              <button onClick={() => go("gestion")} data-testid="banner-gestion"
                className={`w-full text-left rounded-xl border px-4 py-3 text-sm flex items-center gap-3 ${gestion.altos > 0 ? "border-red-200 bg-red-50 text-red-800" : "border-amber-200 bg-amber-50 text-amber-800"}`}>
                <AlertTriangle className="h-4 w-4 shrink-0" />
                <span className="flex-1"><b>{isAdmin || user?.role === "coordinador" ? "Su equipo tiene" : "Tiene"} {gestion.total} pendiente{gestion.total > 1 ? "s" : ""} de gestión</b>
                  {gestion.altos > 0 ? ` (${gestion.altos} urgente${gestion.altos > 1 ? "s" : ""})` : ""}: deudas sin decisión o seguimiento, promesas vencidas y pagarés sin firmar.</span>
                <span className="underline text-xs">Ver y atender</span>
              </button>)}
            <CarteraKpis kpis={data.kpis} clientes={totalClientes} />
            <div className="grid grid-cols-1 xl:grid-cols-5 gap-6 items-start">
              <div className="xl:col-span-3 min-w-0"><EvolucionCard vendedor={vendedor} mes={mes} /></div>
              <div className="xl:col-span-2 min-w-0">
                <AtenderHoy
                  mes={mes}
                  vendedor={vendedor}
                  fechaCorte={fechaCorte}
                  onCliente={(c) => { setFocusCliente(c); go("cuentas"); }}
                  onVerTodos={() => { setFocusCliente(null); go("cuentas"); }}
                  onCargar={() => { setFocusCliente(null); go("cuentas"); }}
                />
              </div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">
              <DocsAnillo />
              <AntiguedadCard kpis={data.kpis} fechaCorte={fechaCorte} vendedor={vendedor} />
            </div>
            <ResumenCoordinador resumen={resumen} vendedor={vendedor} onSelect={setVendedor} />
            {isAdmin && <DirectorioBtn mes={mes} fechaCorte={fechaCorte} />}
            {isAdmin && <AdminReport resumen={resumen} />}
            <RankingVendedores resumen={resumen} isAdmin={isAdmin} />

            <div className="grid lg:grid-cols-2 gap-6">
              <section data-testid="accesos-rapidos" className="rounded-2xl border border-slate-200/80 bg-white p-5 shadow-sm">
                <h3 className="font-heading text-lg font-bold text-emerald-950 mb-4">Accesos rápidos</h3>
                <div className="grid grid-cols-2 gap-3">
                  <div data-testid="qa-importar" className="rounded-xl border border-slate-200 p-3 hover:border-emerald-300 transition-colors">
                    <Upload className="h-5 w-5 text-emerald-700 mb-2" />
                    <div className="text-xs font-semibold text-slate-700 mb-2">Importar Excel/CSV/PDF</div>
                    {can("cargar") ? <ImportModal onImported={reloadAll} vendedores={vendedores} periodo={mes} /> : <p className="text-[11px] text-slate-400">Sin permiso para cargar.</p>}
                  </div>
                  <div data-testid="qa-whatsapp" className="rounded-xl border border-slate-200 p-3 hover:border-emerald-300 transition-colors">
                    <MessageCircle className="h-5 w-5 text-emerald-700 mb-2" />
                    <div className="text-xs font-semibold text-slate-700 mb-2">Enviar por WhatsApp</div>
                    <WhatsAppModal vendedor={vendedor} vendedores={vendedores} fechaCorte={fechaCorte} />
                  </div>
                  <button data-testid="qa-visitas" onClick={() => go("visitas")} className="rounded-xl border border-slate-200 p-3 text-left hover:border-emerald-300 hover:bg-emerald-50/40 transition-colors">
                    <MapPin className="h-5 w-5 text-emerald-700 mb-2" />
                    <div className="text-xs font-semibold text-slate-700">Programar visita</div>
                  </button>
                  <button data-testid="qa-cuentas" onClick={() => go("cuentas")} className="rounded-xl border border-slate-200 p-3 text-left hover:border-emerald-300 hover:bg-emerald-50/40 transition-colors">
                    <Wallet className="h-5 w-5 text-emerald-700 mb-2" />
                    <div className="text-xs font-semibold text-slate-700">Cuentas a recibir</div>
                  </button>
                </div>
                {puedeAjustes && <p className="mt-4 text-[11px] text-slate-400">Permisos, vendedores y borrar datos están en <strong>Ajustes y permisos</strong> (solo administradores).</p>}
              </section>
            </div>
          </div>
        );
      case "cobranzas":
        return (
          <div className="space-y-6">
            <Cobranzas data={data.cobranzas} />
            <CobranzasAcumuladas vendedor={vendedor} mes={mes} />
          </div>
        );
      case "cuentas":
        return (
          <div className="space-y-6">
            {can("cargar") && <Section2Import onImported={reloadAll} vendedores={vendedores} periodo={mes} />}
            <Cuentas data={data.cuentas} canEdit={true} canDelete={canDetalle} onSetLinea={setLinea} onRefresh={() => window.location.reload()} density={density} vendedores={vendedores} focusCliente={focusCliente} onFocusDone={() => setFocusCliente(null)} />
            <ClientesRevision data={data.cuentas} />
            <CarteraAlertas periodo={mes} vendedorActual={vendedor} vendedores={vendedores} isAdmin={isAdmin} />
          </div>
        );
      case "pagares-emitidos":
        return <PagaresEmitidos data={data.pagaresEmitidos} />;
      case "pagares-pendientes":
        return <PagaresPendientes data={data.pagaresPendientes} />;
      case "gestion":
        return <GestionReclamos data={gestion} onReload={cargarGestion} onCliente={(c) => { setFocusCliente(c); go("cuentas"); }} />;
      case "clientes":
        return <ClientesDocs />;
      case "judiciales":
        return judAcceso.ver ? <JudicialesCruce /> : null;
      case "red-riesgo":
        return <RedRiesgo />;
      case "campo-sat":
        return <CampoSatelital isAdmin={isAdmin || isSuperadmin} />;
      case "distribuidoras":
        return <Distribuidoras isAdmin={isAdmin || isSuperadmin} />;
      case "vigilancia":
        return <Vigilancia isAdmin={isAdmin || isSuperadmin} />;
      case "inmuebles":
        return <Inmuebles isAdmin={isAdmin || isSuperadmin} abrirCodigo={inmueblesAbrir} onAbierto={() => setInmueblesAbrir(null)} />;
      case "analisis":
        return (isAdmin || isSuperadmin) ? <AnalisisCliente abrirId={analisisAbrir} onAbierto={() => setAnalisisAbrir(null)} /> : null;
      case "analisis-ext":
        return (isAdmin || isSuperadmin) ? <AnalisisCliente externo={true} /> : null;
      case "deudas-60":
        return <DeudasPlan fechaCorte={fechaCorte} vendedor={vendedor} />;
      case "visitas":
        return <Visitas items={data.visitas} reload={reloadVisitas} canEdit={can("visitas_editar")} vendedores={vendedores} vendedorActual={vendedor} />;
      case "garantias":
        return <Garantias items={data.garantias} reload={reloadGarantias} canEdit={can("garantias_editar")} />;
      case "ajustes":
        if (!puedeAjustes) return null;
        return (
          <div className="space-y-6 max-w-5xl">
            {isAdmin && <ZafraConfig />}
            <div className="rounded-2xl border border-slate-200/80 bg-white p-5 shadow-sm">
              <h3 className="font-heading text-lg font-bold text-emerald-950 mb-1">Usuarios y permisos</h3>
              <p className="text-xs text-slate-400 mb-4">Alta de usuarios, roles y permisos de acceso.</p>
              <AdminUsersModal />
            </div>
            <div className="rounded-2xl border border-slate-200/80 bg-white p-5 shadow-sm">
              <h3 className="font-heading text-lg font-bold text-emerald-950 mb-1">Informes cargados</h3>
              <p className="text-xs text-slate-400 mb-4">Borrar cargas por vendedor y sección (Cuentas / Cobranzas / Pagarés), o todo el período. Papelera con restauración durante 30 días.</p>
              <InformesCargados onChanged={reloadAll} />
            </div>
            {isSuperadmin && (
              <div className="rounded-2xl border border-emerald-200 bg-white p-5 shadow-sm">
                <h3 className="font-heading text-lg font-bold text-emerald-950 mb-1">Permisos por usuario</h3>
                <p className="text-xs text-slate-400 mb-4">Elegí qué puede ver y qué puede hacer cada persona. Solo vos ves esta sección.</p>
                <PermisosUsuarios />
              </div>
            )}
            {isSuperadmin && (
              <div className="rounded-2xl border border-slate-200/80 bg-white p-5 shadow-sm">
                <h3 className="font-heading text-lg font-bold text-emerald-950 mb-1">Acceso a módulos</h3>
                <p className="text-xs text-slate-400 mb-4">Quién puede ver y usar cada módulo restringido.</p>
                <ModuleAccessPanel module="granos" />
              </div>
            )}
            <div className="rounded-2xl border border-slate-200/80 bg-white p-5 shadow-sm">
              <h3 className="font-heading text-lg font-bold text-emerald-950 mb-1">Vendedores</h3>
              <p className="text-xs text-slate-400 mb-4">Catálogo de vendedores (correo y teléfono).</p>
              <VendedoresModal catalog={catalog} onChange={loadCatalog} isAdmin={isAdmin} />
            </div>
            <div className="rounded-2xl border border-slate-200/80 bg-white p-5 shadow-sm">
              <h3 className="font-heading text-lg font-bold text-emerald-950 mb-1">Seguridad</h3>
              <p className="text-xs text-slate-400 mb-4">Cambiar la contraseña de tu cuenta.</p>
              <ChangePasswordModal />
            </div>
            <div className="rounded-2xl border border-red-200 bg-red-50/40 p-5 shadow-sm">
              <h3 className="font-heading text-lg font-bold text-red-900 mb-1">Zona de riesgo</h3>
              <p className="text-xs text-red-500 mb-4">Borrar datos cargados del período. Esta acción no se puede deshacer.</p>
              <ResetDataButton onDone={reloadAll} periodo={mes} vendedor={vendedor} />
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  // Secciones de datos del cliente: sin barra de fechas (muestran siempre lo vigente); solo selector de vendedor compacto donde aplica.
  const SIN_FECHAS = new Set(["inmuebles", "vigilancia", "analisis", "analisis-ext", "judiciales", "garantias", "pagares-terceros", "red-riesgo", "campo-sat", "distribuidoras", "clientes", "carga"]);
  const SOLO_VENDEDOR = new Set([]);   // estas secciones no reciben el filtro de vendedor; el selector compacto queda disponible para cuando alguna lo use
  const showFilters = secActual !== "ajustes" && secActual !== "buscar" && secActual !== "desempeno" && secActual !== "lineas-cobertura" && !SIN_FECHAS.has(secActual);
  const showVendedor = SOLO_VENDEDOR.has(secActual);

  return (
    <div className="min-h-screen bg-[#F1F4F0]">
      <div className="flex flex-col min-h-screen">
        <header className="bg-[#F1F4F0] pt-[env(safe-area-inset-top)]">
          <div className="px-4 sm:px-6 lg:px-8 lg:pl-28 py-3 flex flex-wrap items-center justify-between gap-3">
            <div className="flex items-center gap-4 min-w-0"><Logo /></div>
            <div className="flex flex-wrap items-center justify-end gap-2.5 min-w-0 max-w-full">
              <button onClick={() => go("gestion")} aria-label="Pendientes de gestión" title="Pendientes de gestión" data-testid="header-bandeja"
                className="relative h-11 w-11 rounded-full border border-slate-200 bg-white flex items-center justify-center text-slate-700 hover:bg-slate-50">
                <Bell className="h-[18px] w-[18px]" />
                {gestion?.total > 0 && <span className="absolute top-2 right-2 h-2.5 w-2.5 rounded-full bg-[#B8402A] ring-2 ring-white" />}
              </button>
              <BotonTema />
              {can("guardar_informes") ? <GuardarInforme data={data} vendedor={vendedor} periodo={mes} exportOpts={exportOpts} />
                : <Button variant="outline" className="h-9 border-slate-200 text-slate-400" disabled data-testid="guardar-informe-sin-permiso"
                    title="Sin permiso para guardar informes: pedí al administrador que active «Guardar informes» en Ajustes y permisos → Usuarios y permisos.">
                    <Save className="h-4 w-4 mr-1.5" /> Guardar informe
                  </Button>}

              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button data-testid="mas-acciones-button" variant="outline" className="h-9 border-slate-300 bg-white hover:bg-slate-50">
                    <MoreHorizontal className="h-4 w-4 sm:mr-1.5" /> <span className="hidden sm:inline">Más acciones</span>
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end">
                  <DropdownMenuItem data-testid="download-video-button" onClick={downloadVideo}>
                    <Film className="h-4 w-4 mr-2 text-emerald-700" /> Descargar video resumen (MP4)
                  </DropdownMenuItem>
                  <DropdownMenuItem data-testid="density-toggle" onClick={toggleDensity}>
                    {density === "compact" ? <Rows2 className="h-4 w-4 mr-2 text-emerald-700" /> : <Rows3 className="h-4 w-4 mr-2 text-emerald-700" />}
                    {density === "compact" ? "Vista ampliada" : "Vista compacta"}
                  </DropdownMenuItem>
                  {puedeAjustes && (
                    <>
                      <DropdownMenuSeparator />
                      <DropdownMenuItem data-testid="mas-ajustes-button" onClick={() => go("ajustes")}>
                        <Lock className="h-4 w-4 mr-2 text-slate-500" /> Ajustes y permisos
                      </DropdownMenuItem>
                    </>
                  )}
                  <DropdownMenuSeparator />
                  <DropdownMenuItem data-testid="header-logout" onClick={logout}>Cerrar sesión</DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>

              {can("exportar") && <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button data-testid="export-menu-button" className="h-11 shrink-0 rounded-full tm-negra font-semibold px-5">
                    <FileDown className="h-4 w-4 sm:mr-1.5" /> <span className="hidden sm:inline">Exportar informe</span>
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end">
                  <DropdownMenuItem data-testid="export-pdf-report-button" onClick={handleExportPDF}>
                    <FileText className="h-4 w-4 mr-2 text-red-600" /> Exportar a PDF
                  </DropdownMenuItem>
                  <DropdownMenuItem data-testid="export-excel-report-button" onClick={handleExportExcel}>
                    <Sheet className="h-4 w-4 mr-2 text-emerald-600" /> Exportar a Excel
                  </DropdownMenuItem>
                  <DropdownMenuItem data-testid="export-por-puntos-button" onClick={() => setPuntosOpen(true)}>
                    <ListChecks className="h-4 w-4 mr-2 text-emerald-700" /> Descargar por puntos…
                  </DropdownMenuItem>
                  <DropdownMenuItem data-testid="export-whatsapp-button" onClick={() => setWaOpen(true)}>
                    <Share2 className="h-4 w-4 mr-2 text-emerald-700" /> Descargar para WhatsApp…
                  </DropdownMenuItem>
                  <DropdownMenuItem data-testid="export-image-hd-button" onClick={handleExportImageHD} disabled={hdBusy}>
                    {hdBusy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <ImageIcon className="h-4 w-4 mr-2 text-emerald-700" />}
                    Descargar como foto HD
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>}
              <div aria-label={user?.name || user?.email} title={user?.name || user?.email} data-testid="header-avatar"
                className="h-11 w-11 rounded-full bg-[#007336] text-white font-bold text-sm flex items-center justify-center shrink-0 select-none">
                {(user?.name || user?.email || "?").split(/[\s@.]+/).filter(Boolean).slice(0, 2).map((x) => x[0]).join("").toUpperCase()}
              </div>
            </div>
          </div>
          <div className="px-4 sm:px-6 lg:px-8 lg:pl-28 pb-3 overflow-x-auto scrollbar-none">
            <TopNav section={secActual} onSelect={go} navItems={navVisible} moduleItems={moduleItems} pagaresPend={pagaresPend} isAdmin={puedeAjustes} onOpenAjustes={() => go("ajustes")} onLogout={logout} />
          </div>
          {secActual !== "buscar" && secActual !== "desempeno" && <div className="px-4 sm:px-6 lg:px-8 lg:pl-28 pb-4">
            <h1 className="tm-titulo text-slate-900 break-words" data-testid="titulo-seccion">
              {(() => { const t = SECTION_TITLE[secActual] || "Gestión de cartera"; const i = t.indexOf(" "); return i > 0 ? <>{t.slice(0, i)}<br />{t.slice(i + 1)}</> : t; })()}
            </h1>
            <p className="text-xs font-semibold uppercase tracking-wider text-slate-400 mt-2" data-testid="subtitulo-seccion">{SIN_FECHAS.has(secActual) ? "Datos vigentes del cliente" : "Panel consolidado · valores en USD"}</p>
          </div>}
          {showFilters && (
            <div className="px-4 sm:px-6 lg:px-8 lg:pl-28 pb-4 overflow-x-auto scrollbar-none">
              <div className="bg-white p-3 rounded-2xl !rounded-[22px] !p-3 inline-flex flex-wrap items-center gap-3 min-w-0"><FilterBar /></div>
            </div>
          )}
          {!showFilters && showVendedor && (
            <div className="px-4 sm:px-6 lg:px-8 lg:pl-28 pb-4"><div className="bg-white p-2 rounded-2xl inline-flex items-center"><VendedorBar /></div></div>
          )}
        </header>

        <MenuFlotante acciones={{
          buscar: () => { setFocusCliente(null); go("cuentas"); },
          analisis: (isAdmin || isSuperadmin) && can("analisis") ? () => go("analisis") : null,
          guardados: can("guardar_informes") ? () => document.querySelector('[data-testid="informes-guardados-trigger"]')?.click() : null,
          vencimientos: can("cartera_venc") && canCartera ? () => setShowCartera(true) : () => go("cuentas"),
          exportar: can("exportar") ? () => document.querySelector('[data-testid="export-menu-button"]')?.click() : null,
          whatsapp: () => setWaOpen(true),
          ajustes: puedeAjustes ? () => go("ajustes") : null,
          tema: alternarTema,
        }} />

        <main className="tm-escena flex-1 px-4 sm:px-6 lg:px-8 lg:pl-28 py-6 pb-28 lg:pb-6">
          {renderSection()}
          <footer className="py-8 text-center text-xs text-slate-400">
            © {new Date().getFullYear()} Tecnomyl S.A. — Coordinación de Créditos · Uso interno
          </footer>
        </main>
      </div>

      <ExportPorPuntos open={puntosOpen} onOpenChange={setPuntosOpen} data={data} exportOpts={exportOpts} mes={mes} vendedor={vendedor} />
      <DescargarWhatsApp open={waOpen} onOpenChange={setWaOpen} mes={mes} vendedor={vendedor} />
      <AnalizarPagare open={showPagareIA} onOpenChange={setShowPagareIA} />
    </div>
  );
}
